export const formatStringToDate = (date: string): Date | null => {
  if (!date || date.length !== 10) return null;
  const year = date.substring(0, 4);
  const month = date.substring(4, 6);
  const day = date.substring(6, 8);
  return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), 0, 0, 0, 0);
};

export const formatStringToISODate = (date: string): string => {
  const formatted = formatStringToDate(date);
  return formatted ? formatted.toISOString().substring(0, 10) : '';
};

export const formatPersonalNumber = (personalNumber?: string): string | null => {
  if (!personalNumber || personalNumber.length !== 12) return null;
  const year = personalNumber.substring(0, 4);
  const month = personalNumber.substring(4, 6);
  const day = personalNumber.substring(6, 8);
  const lastFourDigits = personalNumber.substring(8);
  return `${year}${month}${day}-${lastFourDigits}`;
};
